import { render } from "./AdminVoucher.vue?vue&type=template&id=66855fd0"
import script from "./AdminVoucher.vue?vue&type=script&lang=js"
export * from "./AdminVoucher.vue?vue&type=script&lang=js"

import exportComponent from "C:\\mgtspl\\mgtspl\\MGTSPL_FE\\MGTSPL\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__